import { render, staticRenderFns } from "./ConfirmPromotionChangeDialog.vue?vue&type=template&id=648017cf"
import script from "./ConfirmPromotionChangeDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmPromotionChangeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports